import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

function LocalTimeZone(props) {
    const { dateTime } = props;
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const convertedDateTime = dayjs(dateTime).tz(userTimeZone).format('ddd, MMM D, YYYY h:mm A');
    return convertedDateTime;
}

export default LocalTimeZone;
